var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"fullscreen-loading"}},[_c('div',{staticClass:"logo-loading-container d-flex align-items-center justify-content-center w-100 h-100"},[_c('img',{attrs:{"loading":"lazy","src":require("@/assets/img/Transparent.png"),"alt":"Loading..."}})])])
}]

export { render, staticRenderFns }